import { render, staticRenderFns } from "./DialogForm.vue?vue&type=template&id=f069cbec&scoped=true&"
import script from "./DialogForm.vue?vue&type=script&lang=ts&"
export * from "./DialogForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f069cbec",
  null
  
)

export default component.exports